import { useReducer } from "react";
import Reducer from "./Reducer";
import InitialState from "./InitialState";
import Context from "./Context";
import * as Sentry from "@sentry/react";
import Pool from "../UserPool";
import {
  CognitoUser,
  AuthenticationDetails,
  CognitoUserAttribute,
  CookieStorage,
} from "amazon-cognito-identity-js";
import { ON_SET_USER_INFO, ON_RESTABLECER_USER_INFO } from "./Types";
import Cookies from "js-cookie";
import axios from "axios";

const Actions = (props) => {
  const [state, dispatch] = useReducer(Reducer, InitialState);

  const isApp = window.location.href.includes("app");

  const onSetUserInfo = (userData) => {
    dispatch({ type: ON_SET_USER_INFO, payload: userData });
  };

  const onRestablecerUserInfo = () => {
    dispatch({ type: ON_RESTABLECER_USER_INFO });
  };

  const getIdentityByUsername = (identity) => {
    switch (identity) {
      case "Google":
        return 2;
      case "Facebook":
        return 3;
      case "Apple":
        return 4;
      default:
        return 2;
    }
  };

  const authenticate = async (Username, Password) => {
    return await new Promise((resolve, reject) => {
      const user = new CognitoUser({
        Username,
        Pool,
        Storage: new CookieStorage({ domain: process.env.MIX_COOKIE_DOMAIN }),
      });
      const dataEmail = {
        Name: "email",
        Value: Username,
      };
      const userAttribute = new CognitoUserAttribute(dataEmail);
      const authDetails = new AuthenticationDetails({ Username, Password });

      user.authenticateUser(authDetails, {
        onSuccess: (data) => {
          addUserSessionCookie(Username);
          resolve(data);
        },
        onFailure: (err) => {
          // alert(err);
          Sentry.captureException(
            err,
            "Something is wrong Actions, function authenticate"
          );
          reject(err);
        },
        newPasswordRequired: (data) => {
          resolve(data);
        },
      });
    });
  };

  function addUserSessionCookie(email) {
    document.cookie = `UserSession=${encodeURIComponent(
      JSON.stringify({email: email}),
    )};path=/`;
  }
  
  const getUsuariosBySession = (email) => {
    axios
      .get(
        `${process.env.MIX_URL_API}${process.env.MIX_API_VERSION}/login/usuarios/?email=${email}`
      )
      .then((result) => {
        if (result.data.email) {
          const data = result.data;
          onSetUserInfo({
            name: data.name,
            email: data.email,
            picture: data.picture,
            identity: data.identity,
            tipo: data.tipo,
          });
          addUserSessionCookie(data.email);
        }
      })
  };

  const getOldCookies = () => {
    const cookies = [];
    if (document.cookie && document.cookie != "") {
      const split = document.cookie.split(";");
      for (let i = 0; i < split.length; i++) {
        const nameValue = split[i].split("=");
        nameValue[0] = nameValue[0].replace(/^ /, "");
        if (
          nameValue[0].includes("consulta") ||
          nameValue[0].includes("UserSession") ||
          nameValue[0].includes("pricett") ||
          nameValue[0].includes("tourFicha") ||
          nameValue[0].includes("login_cliente") ||
          nameValue[0].includes("mt") ||
          nameValue[0].includes("wsppDesktop") ||
          nameValue[0].includes("v") ||
          nameValue[0].includes("tooltipFecha") ||
          nameValue[0].includes("modalprovincia") ||
          nameValue[0].includes("busquedas_recientes") ||
          nameValue[0].includes("rv") ||
          nameValue[0].includes("dp") ||
          nameValue[0].includes("da") ||
          nameValue[0].includes("CognitoIdentityServiceProvider")
        ) {
          cookies.push(nameValue[0]);
        }
      }
    }
    return cookies;
  };

  const deleteOldCookies = () => {
    const oldCookies = getOldCookies();
    oldCookies.forEach((element) => {
      Cookies.remove(element, {
        path: "",
        domain: process.env.MIX_COOKIE_DOMAIN,
      });
    });
  };

  const getSession = async () => {
    return await new Promise((resolve, reject) => {
      const user = Pool.getCurrentUser();
      if (user != null) {
        user.getSession(function (err, session) {
          if (err) {
            reject(err);
            Sentry.captureException(
              err,
              "Something is wrong Actions, function getSession"
            );
          } else {
            resolve(session);
          }
          // si viene identities significa que viene de google y facebook
          if (user.signInUserSession.idToken.payload.identities) {
            const datosUser = user.signInUserSession.idToken.payload;
            getUsuariosBySession(datosUser.email);
          } else {
            user.getUserAttributes(function (err, attributes) {
              attributes.map((attribute) => {
                if (attribute.Name == "email") {
                  getUsuariosBySession(attribute.Value);
                }
              });
            });
          }
        });
      } else {
        // si se cerro la sesion y por algun motivo quedaron las cookies de cognito almacenadas las borro
        if (getOldCookies().length) {
          deleteOldCookies();
        }
        reject();
      }
    })
  };

  const logOut = () => {
    const user = Pool.getCurrentUser();
    if (user) {
      if (state.identity == 2) {
        user.signOut();
        onRestablecerUserInfo();
        const urlLogoutGoogle = `${
          process.env.MIX_DOMAIN_COGNITO
        }/logout?client_id=${process.env.MIX_CLIENT_ID_COGNITO}&logout_uri=${
          !isApp ? process.env.MIX_DOMINIO_WEB : process.env.MIX_DOMINIO_APP
        }/`;
        window.open(urlLogoutGoogle, "_self");
        return;
      }
      user.signOut();
      onRestablecerUserInfo();
      deleteOldCookies();
      location.reload();
    }
  };

  const redirectIfLogged = (tipo) => {
    const user = Pool.getCurrentUser();
    const redirect = window.g.redirect;
    if (!user) return;
    if (!redirect) return window.location.replace(process.env.MIX_DOMINIO_WEB);

    const hostname = new URL(redirect).hostname; // Obtenemos el hostname completo
    const [subdomain] = hostname.split("."); // Extraemos el primer segmento
   
    if (tipo !== 2 && subdomain === "clientes") {
      return window.location.replace("/");
    }
    if (redirect === "pdc-lite" && tipo === 2) {
      return window.location.replace(process.env.MIX_URL_PDC_LITE);
    }
    return window.location.replace(redirect);
  };


  const refreshToken = () => {
    const { UserPoolId } = pool;
    const user = Pool.getCurrentUser();
    const refresh_token = user.getRefreshToken();
    cognitoUser.refreshSession(refresh_token, (err, session) => {
      if (err) {
        console.log(err);
      } else {
        // AWS.config.credentials.params.Logins[
        //   `${process.env.MIX_DOMAIN_COGNITO}/${UserPoolId}`
        // ] = session.getIdToken().getJwtToken();
        // AWS.config.credentials.refresh((err) => {
        //   if (err) {
        //     console.log(err);
        //   } else {
        //     console.log("TOKEN SUCCESSFULLY UPDATED");
        //   }
        // });
      }
    });
  };
  return (
    <Context.Provider
      value={{
        state: state,
        onSetUserInfo,
        onRestablecerUserInfo,
        logOut,
        authenticate,
        getSession,
        getIdentityByUsername,
        redirectIfLogged,
        getOldCookies,
        deleteOldCookies,
        refreshToken,
      }}
    >
      {props.children}
    </Context.Provider>
  );
};

export default Actions;
